<!-- PWA Installation Prompt -->
<div class="pwa-install-banner" *ngIf="showPrompt" role="banner" aria-live="polite">
  <div class="banner-content">
    <!-- App Icon -->
    <div class="app-icon">
      <img src="assets/icons/icon-72x72.png" alt="ePortal App Icon" width="48" height="48">
    </div>

    <!-- Main Content -->
    <div class="banner-text">
      <h4 class="banner-title">{{ 'PWA.InstallTitle' | translate }}</h4>
      <p class="banner-description">
        {{ 'PWA.InstallDescription' | translate }}
      </p>

      <!-- iOS specific instructions -->
      <div class="ios-instructions" *ngIf="isIOS && !canInstallDirectly">
        <p class="instructions-title">{{ 'PWA.IOSInstructionsTitle' | translate }}:</p>
        <ol class="instructions-list">
          <li *ngFor="let instruction of getIOSInstructions()">{{ instruction }}</li>
        </ol>
      </div>
    </div>

    <!-- Action Buttons -->
    <div class="banner-actions">
      <!-- Install button for supported browsers -->
      <button 
        *ngIf="canInstallDirectly" 
        type="button" 
        class="btn btn-primary btn-sm install-btn"
        [disabled]="isInstalling"
        (click)="installApp()"
        [attr.aria-label]="'PWA.InstallButton' | translate">
        <span class="bi bi-download" *ngIf="!isInstalling" aria-hidden="true"></span>
        <span class="spinner-border spinner-border-sm" *ngIf="isInstalling" aria-hidden="true"></span>
        {{ (isInstalling ? 'PWA.Installing' : 'PWA.InstallButton') | translate }}
      </button>

      <!-- iOS Safari instruction button -->
      <button 
        *ngIf="isIOS && !canInstallDirectly" 
        type="button" 
        class="btn btn-outline-primary btn-sm"
        (click)="dismissPrompt()"
        [attr.aria-label]="'PWA.GotItButton' | translate">
        <span class="bi bi-check-lg" aria-hidden="true"></span>
        {{ 'PWA.GotItButton' | translate }}
      </button>

      <!-- Dismiss button -->
      <button 
        type="button" 
        class="btn btn-link btn-sm dismiss-btn"
        (click)="dismissPrompt()"
        [attr.aria-label]="'PWA.DismissButton' | translate">
        <span class="bi bi-x-lg" aria-hidden="true"></span>
        {{ 'PWA.DismissButton' | translate }}
      </button>
    </div>
  </div>
</div>
